export default {
    app: {
        actions: {
            add: 'create',
            addAndNew: 'add & new',
            cancel: 'cancel',
            ok: 'ok',
            save: 'save',
            saveContinue: 'save and continue >>',
            download: 'download',
            edit: 'edit',
            upload: 'upload'
        },
        underConstruction: 'This website is under construction.',
        applicationName: 'Chess Administrator',
        menu: {
            tournaments: 'tournaments',
            clubs: 'clubs',
            chessPlayers: 'players',
            login: 'login',
            logout: 'logout',
            merchandise: 'New: support the site, buy merchandise!'
        },
        footer: {
            copyright: 'copyright',
            termsAndConditions: 'terms of service',
            privacyStatement: 'privacy statement',
            contact: 'contact',
            about: 'about'
        }
    },
    contact: {
        contactIntro: 'Here you can leave a message for the site owner. We would like to hear what is good and what can be improved.',
        email: 'your e-mailaddress',
        remarks: 'leave your remarks here',
        robotSecure: 'robot check',
        robotTextFinish: ' wins.',
        robotTextStart: 'white begins, ',
        send: 'send',
        sendSucces: 'feedback sent succesfully, thank you!'
    },
    dashboard: {
        freeSubscription: 'Sign up for free',
        adText: 'Easy online organizing tool <br/>for club competitions or chess tournaments',
        involvement: 'involvement',
        recentlyVisited: 'recently visited',
        notOrganizing: 'You are not organizing any tournaments',
        notParticipating: 'You are not participating in any tournaments',
        notMember: 'You do not seem to be member of any club',
        menu: {
            defaultInfo: 'Find tournaments, search clubs or investigate your favourite players',
            tournamentsInfo: 'An overview of running tournaments and tournament results',
            clubsInfo: 'See wich clubs are organizing tournaments, have a look at their members etc.',
            chessPlayersInfo: 'You can have a view on a players\' results and tournaments played',
        },
        search: 'find tournaments, players or clubs',
        siteExplanation: {
            title: 'Why should I become a member?',
            unregistered: 'As an unregistered user, you can access tournament results as well as some club and player information.' +
                'Free membership offers various advantages:',
            personalPage: {
                title: 'Personal pages',
                text: 'You will get a nice overview of your own results and current and coming tournaments.'
            },
            knsbConnection: {
                title: 'Automatic binding to public Federation accounts',
                text: 'By linking your account to a Federation player account, a tournament oraniser will automatically have the ' +
                    'required registration information, when you register for a tournament through schaaktoernooien.nl.'
            },
            tournamentByes: {
                title: 'Availability',
                text: 'Per round of a tournament, you can set your availability on this site. THe organiser will be informed ' +
                    'instantly and can easily have a new pairing available.'
            },
            notifications: {
                title: 'Notifications',
                text: 'Receive messages when a new pairing has been made available, or after changes to this schedule. This ' +
                'way you are informed up front of your opponent for the coming round.'
            },
            organize: {
                title: 'Organize your own tournament!',
                text: 'Every registered user can create his/her own tournament. Clubs can maintain their internal competition here, ' +
                    'tournament organisations can alo run and register lager tournaments on schaaktoernooien.nl. Are you organising ' +
                    'a fun home round robin? Then you can also quickly generate the playing schedule here.'
            }
        },
    },
    group: {
        addGroup: 'add group',
        editGroup: 'edit group'
    },
    management: {
        playerImport: 'player import',
        importStatus: 'player import has started. This will take a few minutes, this will take some patience. The status:'
    },
    match: {
        blackPlayer: 'black pieces',
        fix: '(un)fix this match', 
        result: 'result',
        selectPlayer: 'select a player',
        whitePlayer: 'white pieces'
    },
    round: {
        addRound: 'add round',
        date: 'date (dd-mm-yyyy)',
        editRound: 'edit round',
        noRounds: 'no rounds have been created'
    },
    registration: {
        absent: 'absent',
        addRegistrations: 'add player(s)',
        available: 'available',
        availability: 'availability',
        availabilityExplanation: 'availability used for new rounds',
        deletePlayer: 'delete this player',
        editPlayer: 'edit this player',
        estimatedELO: 'estimated ELO rating',
        federationNumber: 'federation number',
        federationPlayer: 'federation player',
        loading: 'players loading...',
        name: 'name',
        newPlayer: 'new player',
        playerType: 'player type',
        residence: 'residence',
        selectClub: 'select a club',
        updateRegistration: 'update player information'
    },
    tournament: {
        absenceAddedAs: ' was added as ',
        absenceReason: 'reason for absence',
        addAbsence: 'add a participant as absent',
        addGroup: 'add group',
        addMatch: 'add match',
        addPlayer: 'add player',
        calculate: 'calculate',
        createPairing: 'create pairing',
        createStaticSite: 'create static site',
        deleteGroup: 'delete this group',
        deleteTournament: 'delete this tournament',
        description: 'extra description',
        details: 'tournament details',
        editMatch: 'edit match',
        editTournament: 'edit tournament details',
        edition: 'edition',
        entry: 'entry',
        extraNotes: 'supplementary information on the tournament',
        finishRound: 'finish round',
        from: 'from',
        fromRound: 'first round to include',
        generalInformation: 'general',
        location: 'location',
        management: 'management',
        managers: 'tournament managers',
        managersText: 'here, the current tournament managers are shown. you can add and remove other persons to also act as a manager for this tournament',
        organisingMyself: 'personally organized',
        organizer: 'organizer',
        noPlayerSelected: 'no player selected',
        noReasonSelected: 'no reason selected',
        notifications: 'notifications',
        pairing: 'pairing',
        pairingApproved: 'pairing approved',
        pairingAndScoring: 'pairing and scoring',
        pairingSystem: 'pairing system',
        period: 'period',
        player: 'player',  
        playerResults: 'player results',  
        ratingReport: 'rating report', 
        reopenRound: 're-open round',
        reportText: 'chess administrator can create your rating report in FIDE format, which most federations accept. ' +
                       'generation and download will start after pressing the "download" button.',
        resultUpload: 'upload results using SFTP',
        scoring: 'scoring',
        selectFromRound: 'select the first round to report',
        selectUntilRound: 'select the last round to report',
        sftpKeyfile: 'SFTP key',
        sftpLocation: 'SFTP location',
        sftpPassword: 'password',
        sftpUser: 'user name',
        selectType: 'select your tournament type',
        tempo: 'tempo',
        tournament: 'tournament',
        until: 'until',
        untilRound: 'last round to report',
        upload: 'upload',
        uploadExplanation: 'to create static html pages which can ben used for the website of your club',
        youAreManager: 'you are the tournament manager',
        youAreParticipant: 'you are/were a participant in this tournament',
        selectManager: {
            add: 'add manager',
            header: 'add a manager',
            select: 'select'
        }
    },
    tournaments: {
        actions: 'actions',
        absences: 'absences',
        absence: 'absence',
        B: 'b',
        bTitle: 'number of games with black',
        search: 'find tournament',
        create: 'new tournament',
        draw: '½',
        drawTitle: 'number of games drawn',
        elo: 'elo',
        eloTitle: 'ELO rating',
        entryForm: 'entry form',
        found: 'tournaments found',
        group: 'group',
        lost: '0',
        lostTitle: 'number of lost games',
        match: 'match',
        matches: 'matches',
        name: 'name',
        noAbsences: 'there are no absences for this round',
        noparing: 'no pairing available for this round',
        noplayers: 'there are no players available in this group',
        points: 'points',
        pointsTitle: 'total of points, 1 for win, ½ for a draw, also includes absence scores',
        reason: "reason",
        registrations: 'registrations',
        results: 'results',
        round: 'round',
        rounds: 'rounds',
        sb: 'sb',
        sbTitle: 'Sonneborn-Berger score',
        score: 'score',
        standings: 'standings after round',
        tpr: 'tpr',
        tprGain: 'tpr gain',
        tprGainTitle: 'TPR related to starting ELO this tournament',
        tprStandings: 'TPR classification after round',
        tprTitle: 'tournament performance rating',
        value: 'value',
        valueTitle: 'your Keizer value, determined by the rank, per round',
        W: 'w ',
        wp: 'bh ',
        wpTitle: 'Bucholz',
        won: '1',
        wonTitle: 'number of games won',
        wTitle: 'number of games with white'
    },
    settings: {
        settings: 'settings',
        userSettings: 'user settings',
        userAccount: 'external account',
        username: 'user login',
        linkedTo: 'account linked to:',
        moreInfo: 'more information',
        notLinked: 'not linked',
        account: 'account',
        linkToAccount: 'link account',
        linkToOtherAccount: 'change link',
        password: 'password',
        interface: 'interface',
        language: 'langauge',
        theme: 'theme'
    },
    sftp: {
        host: 'host',
        noHost: 'no host provided',
        noTargetLocation: 'no target location provided',
        noUser: 'no user name provided',
        uploadTitle: 'upload static html to your club website (sftp)',
        username: 'user name',
        password: 'password',
        targetLocation: 'target folder on ftp server',
        uploadInProgress: 'upload in progress, this can take a minute'
    },
    signin: {
        confirmationNeeded: 'you need to confirm your e-mailaddress before logging in. please check your mail.',
        confirmationNotReceived: 'I did not receive a confirmation e-mail',
        confirmationResend: 'I think I need another confirmation e-mail',
        confirmationSucces: 'your email was successfully verified. you can login with the credentials you created',
        loginFailed: 'login failed',
        username: 'user name',
        password: 'password', 
        forgotPassword: 'forgot your password?',
        requestPassword: 'request new password',
        requestPasswordButton: 'new password',
        passwordResetMsgSent: 'we have sent you an e-mail containing a link. using that link, you can create a new password.',
        passwordResetMessage: 'your password was succesfully reset. you can login to ChessAdministrator with your new credentials.',
        sessionTimedOut: 'your session expired after a certain amount of time. you tried to perform an actions that requires to be logged in. please log in and try again.',
        createAccount: 'create account',
        waitingForConfirmation: 'Thank you for you registration. After confirming your e-mail account with the link we just sent you, you can login and you are good to go!',
        welcome: 'Welcome to Chess Administrator. Login to register for a tournament, or host your own tournament!'
    },
    signup: {
        accountAvailable: 'already have an account?',
        confirmationSucces: 'the e-mail confirmation was successful. you can proceed to sign in and enjoy the full functionality of this application.',
        containsCapital: 'contains a capital',
        containsLowercase: 'contains a lowercase',
        containsNumber: 'contains a number',
        eightCharacters: 'at least 8 characters',
        forgotPasswordText: 'when you forgot your password, you can request to create a new password. fill out your username (this can be found in your welcome e-mail) and we will send you instructions',
        fourCharacters: 'at least 4 characters, no spaces',
        onlyCharactersAndDigits: 'contains only characters and digits',
        passwordsEqual: 'passwords are equal',
        register: 'register',
        sideText: 'create an account to participate in tournaments, or host your own!',
        validEmail: 'valid e-mail address',
        emailConfirmation: 'email confirmation',
        confirmationWaiting: 'you have used the confirmation link we sent you. your token is being verified.',
        toSignin: 'to login',
        confirmationNotReceivedheader: 'did not receive a confirmation e-mail?',
        confirmationResendInformation: 'in order to login on ChessAdministrator your e-mailaddress needs to be verified. if you did not receive such a message, or you link expired, fill out your e-mail address below and click "resend" to generate another confirmation e-mail.',
        resend: 'resend'
    },
    beta: {
        chessAdministratorBeta: 'Chess Administrator bèta',
        paragraph1: 'This site is still under construction. Functionality will be used by our local chess club, for live testing purposes. You can use this site at your own discretion, no guarantees are given until the first official point release. (although we need the current Functionality ourselves as well). Operational details are still subject to change.',
        paragraph2: 'You are welcome to give feedback on the chess administrator program. Please provide a reproducing scenario when reporting a bug. Functional requirements / improvements will be considered and may be placed on a backlog. We try to keep the site as clean as possible, thus, keeping the options constrained. We try to focus on user experience and simplicity while providing the best and stable administration program possible.',
        paragraph3: 'Enjoy using this site! (and please consider donating ;-))',
        paragraph4: 'Chess Administrator, since 2022'
    },
    clubs: {
        search: 'find club',
        federation: 'federation',
        found: 'clubs found',
        code: 'code',
    },
    person: {
        noClub: 'not a club member',
        tournament: 'tournament',
        rank: 'rank',
        rating: 'rating',
        ratingDifference: 'difference',
        ratingList: 'rating list',
        score: 'score',
        tpr: 'tpr',
        outOf: 'uit'
    },
    selectUser: {
        filterClub: 'club filter',
        impersonationFailed: 'Impersonation failed. The selected person is already linked to another account. Is this really you? Please contact the site administrator.',
        join: 'Join the club!',
        link: 'link to this user',
        moreInfo: 'more information on linking your account',
        noMember: 'I am not a member of any club',
        player: 'player',
        selectYourself: 'select yourself',
        sideText: 'Your successfully created an account. In order to make the best use of this application, we advise you to link your account to a federation account.',
        thisIsMe: 'this is me'
    },
    persons: {
        code: 'code',
        federation: 'federation',
        federationNumber: 'federation number',
        found: 'persons found',
        latestRanking: 'current ranking',
        noRunningTournaments: 'not playing tournaments at this moment',
        noTournamentsPlayed: 'this player did not play any completed tournaments via Chess Administrator',
        outOf: 'out of',
        rating: 'rating',
        search: 'find player'
    },
    info: {
        about: {
            heroTitle: 'Chess Administrator. Your complete chess world, organized',
            heroSubtitle: 'From spectator to organizer. Discover the platform that thinks along.',
            signUpAndStart: 'Join for free & start immediately',
            justGo: 'just continue to the site >>',
            moreThanJustResults: 'More than just viewing results',
            more1: 'As a visitor, you see what has happened. As a member, you decide what happens next. Registration is free and opens the door to a more personalized experience and the opportunity to organize events yourself. And in all cases: no ads, no trackers.',
            yourChessCareer: 'Focus on your chess career',
            career1: 'All your results, rating progress, and upcoming tournaments on one central dashboard. Easily link your account to your KNSB ID so organizers immediately have the correct information.',
            neverMissAMove: 'Never miss a move',
            miss1: 'Easily sign up or opt-out for tournament rounds with a single click. Receive instant notifications as soon as pairings are made and when results are posted.',
            organizeProfessional: 'Organize professionally',
            organize1: 'Every user can start their own tournament. Manage your internal club competition or register large events in this system. Generate your pairing schedules for Keizer or Swiss systems in no time.',
            readyToMakeYourMove: 'Ready to make your move?',
            memberLoginHere: 'Already a member? Log in here',
            goToStart: 'Continue to the homepage',
            createFreeAccount: 'Create your free account now'
        },
        donate: {
            header: 'Donate',
            intro: 'Do you enjoy using Chess Administrator?',
            paragraph1: 'Then please consider a donation!',            
            paragraph2: 'Chess Administrator is created by enthusiasts, with the goal of making things as easy as possible for organizers and keeping players well-informed about their participation.',
            paragraph3: 'Many evenings and weekends of work have been put in with love. You can use this labor -fueled by black coffee, some blond beer, and relaxing bike rides through the beautiful polders of the Netherlands- for free.',
            paragraph4: 'However, server costs, domain registration, etc., are recurring expenses. A few euros per year should be manageable for the average club, right? A small contribution would therefore be greatly appreciated! It also inspires the further development and improvement of the website.',
            paragraph5: 'Donations can be made via "Buy Me a Coffee", accessible via the button below.'                
        },
        linkingAccount: {
            header: 'linking your account',
            intro: 'in this program you can select your own federation account to link to. This will have various advantages while using Chess Administrator:',
            maybeNextTime: 'maybe next time',
            yesIWill: 'yes, I want to link my account',
            advantage1Title: 'Registering',
            advantage1Text: 'When registering for a tournament on Chess Administrator, the organiser immediately receives all the nessecary information needed. For example, rating reportings can be easily created and you do not have to supply your rating.',
            advantage2Title: 'Organising',
            advantage2Text: 'When organising a tournament, the program assumes you are organising on behalf of your club and it will be much easier to add and invite your club members.',
            advantage3Title: 'Selected the wrong person?',
            advantage3Text: 'If you accidentally selected another person instead of yourself, you can correct this using the menu option "settings", after clicking your name in the top right. Abuse of this option, impersonating other people on purpose, will be penalised, banning your account.',
        },
        version: {
            header: 'Version information',
            intro: 'This page displays the version information for Chess Administrator. A summary of all available functionality, along with several planned improvements currently on the implementation list.',
            beta: 'Beta',
            betaIntro: 'This version was active from 2022 through 2025. Over time, various extensions were added, all of which have since been extensively tested and made available.',
            beta1: 'User registration',
            beta2: 'Tournament organization',
            beta3: 'Pairings based on the Keizer system',
            beta4: 'Email notifications for registered users, including results and pairings',
            beta5: 'Up-to-date KNSB data for easily adding participants with the correct details (ID, current rating)',
            beta6: 'Multiple groups per tournament',
            beta7: 'FIDE report export for rating processing purposes',
            bastion: 'Bastion 1.0',
            bastionIntro: 'This version is available from 01-01-2026, officially marking the end of the Beta phase. This version has been given a fresh coat of paint for a sleeker and more professional appearance, matching the reliability expected from pairing software. Under the hood, several significant changes have been made:',
            bastiont1: 'A new database, better securing the future of this program',
            bastiont2: 'Separate Test and Production environments',
            bastiont3: 'Renewed email delivery service',
            bastiont4: '.NET Framework updated',
            bastiont5: 'Official domain name registration',
            bastiont6: 'Adjustments for up-to-date rating imports',
            bastionFunctionalImprovements: 'There are also functional improvements:',
            bastionf1: 'Swiss pairings (feature still in Beta)',
            bastionf2: 'Splash screen with information',
            bastionf3: 'Various minor adjustments: improved sorting, button functionality',
            bastionf4: 'Unit tests for the pairing algorithms',
            bastionf5: 'Refresh tokens, to maintain the connection even when entering results throughout an entire evening',
            bastionf6: 'And, while not directly a feature of this site, a nice extra: a merchandise site',
            improvements: 'Known areas for improvement currently being worked on:',
            improvement1: 'Management options disappear after creating a new tournament',
            improvement2: 'Display active round results when opening a tournament'
        }
    },
    changePassword: 'change password',
    login: 'login'
};
